import store from '@/store'
import { app } from '@/main.js'
import { useToast } from 'vue-toastification'
import router from '@/router'


const toast = useToast()


export default (to, from, next) => {
  let isAdmin = false;

  if (app?.helpers?.getTokenParam()){
    store.commit('auth/setToken', app.helpers.getTokenParam());
  }

  if (store.state.auth.jwtPayload == null){
    store.dispatch('auth/logout', { logoutAuth: false });
    return;
  }

  if (store.state.auth.jwtPayload.organisation_role && store.state.auth.jwtPayload.organisation_role[0]) {
    const products = store.state.auth.jwtPayload.organisation_role[0].products || [];
    for (const product of products) {
      if (product.product === "cyber_security_online_awareness_training" || product.product === "training") {
        isAdmin = product.roles && product.roles.includes("admin");
      }
    }
  }

  const isOrgAdminWithTraining = Boolean(
    store.state.user.organisation &&
    store.state.user.organisation.is_organisation_admin &&
    store.state.auth.hasTraining
  );

  if (!store.state.auth.isSuperAdmin && !isAdmin && !isOrgAdminWithTraining) {
    toast.error("Only training admins are allowed to view this page.");
    return router.push('/training/assigned-training');
  }

  return next()
}

